// extracted by mini-css-extract-plugin
module.exports = {"slide":"Two_slide__3448A","background":"Two_background__k6nq7","wrapper":"Two_wrapper__3OYjA","notebook":"Two_notebook__4Jc1h","arcticle":"Two_arcticle__1NRjg"};